export function mobileNav() {
    const body = $("body");
    const btnMenu = $(".menu-opener");
    const mainNav = $('.main-nav');
    const mainNavItems = mainNav.find('.menu-item-has-children');
    const arrowButton = `<button class="arrow-button">
                            <svg width="16" height="10" viewBox="0 0 16 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1 1L8 9L15 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                            </svg>
                        </button>`;
    let activeMenuItem;

    btnMenu.on("click", function (e) {
        body.toggleClass("menu-opened");
        e.preventDefault();
    });

    $('.open-search-button').on('click', function (e) {
        $(this).hide();
        body.addClass("search-opened");
        e.preventDefault();
    })

    mainNavItems.each((i, item) => {
        const menuList = $(item).find(' > .sub-menu');
        if (!$(item).find('.arrow').length) {
            $(arrowButton).insertBefore(menuList, null);
        }
    });


    $(document).on("click", ".main-nav .menu-item-has-children .arrow-button", function (e) {
        activeMenuItem = $(this).parent();
        if (window.innerWidth < 1024) {
            if (!activeMenuItem.hasClass("active")) {
                activeMenuItem.siblings().removeClass('active').find(".sub-menu").slideUp();
                activeMenuItem.addClass("active").find(".sub-menu").slideDown();
            } else {
                activeMenuItem.removeClass("active").find(".sub-menu").slideUp();
            }
        }
        if (window.innerWidth > 1023 && body.hasClass('touch')) {
            if (!activeMenuItem.hasClass("active")) {
                activeMenuItem.siblings().removeClass('active').find(".sub-menu").fadeOut();
                activeMenuItem.addClass("active").find(".sub-menu").fadeIn();
            } else {
                activeMenuItem.removeClass("active").find(".sub-menu").fadeOut();
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/mobileNav.js